import React from 'react';
import './welcomeTable.scss';

const WelcomeTable = (props) => {

  const {fetchLoading} = props;

  return (
    <div className="center">
      {fetchLoading ?
        <div>
          {/* <p style={{'marginLeft' : '4%'}}>Please Wait...</p> */}
        </div>
        :
        <div>
          <p className='txtWelcm'> Welcome!</p>
          <p className='chTable'>Choose any table to view the data</p>
          <p className='fndTbl'>You can find the tables form the left side closable menu</p>
        </div>}
    </div>
  );
};

export default WelcomeTable;
